/**
 * Measurements spine: bulk sample write (`POST /v2/stats/measurements`) and
 * daily entry (`GET /v2/stats/daily`).
 *
 * Write: DAILY metrics = upsert per day (re-sending is a CORRECTION);
 * a `businessDate` in the past = backfill (future dates → 400). The `unit`
 * field per sample carries the user's unit — the BE converts it to
 * canonical (S-ODL-64). For a client (trainer with edit consent), use
 * `…/client/:clientId`.
 */
import type { ApiRecordMeasurementsDto } from '@mfw/common';

import type {
  RecordMeasurementsResult,
  FetchDailyArgs,
  ApiDaily,
} from './types/stats.types';

import { post, get } from './axios';

export const recordMeasurements = async ({
  clientId,
  ...dto
}: ApiRecordMeasurementsDto & { clientId?: string }) => {
  const url = clientId
    ? `/v2/stats/measurements/client/${clientId}`
    : '/v2/stats/measurements';
  const response = await post<RecordMeasurementsResult>(url, dto);
  return (response ?? null) as RecordMeasurementsResult | null;
};

export const fetchDaily = async (args: FetchDailyArgs = {}) => {
  const response = await get<ApiDaily>('/v2/stats/daily', {
    query: { date: args.date, clientId: args.clientId },
  });
  return response ?? null;
};
